<!-- .block-products original template version -->
<!-- <div class="block block-products block-products--layout--{{ layout }}">
    <div class="container">
        <app-block-header [header]="header"></app-block-header>

        <div class="block-products__body">
            <ng-template #largeTemplate>
                <ng-container *ngIf="large !== null">
                    <div class="block-products__featured">
                        <div class="block-products__featured-item">
                            <app-product-card [product]="large"></app-product-card>
                        </div>
                    </div>
                </ng-container>
            </ng-template>
            <ng-template #smallsTemplate>
                <div *ngIf="smalls.length > 0" class="block-products__list">
                    <div *ngFor="let product of smalls" class="block-products__list-item">
                        <app-product-card [product]="product"></app-product-card>
                    </div>
                </div>
            </ng-template>

            <ng-container *ngIf="layout === 'large-last'" [ngTemplateOutlet]="smallsTemplate"></ng-container>
            <ng-container [ngTemplateOutlet]="largeTemplate"></ng-container>
            <ng-container *ngIf="layout === 'large-first'" [ngTemplateOutlet]="smallsTemplate"></ng-container>

        </div>
    </div>
</div> -->
<!-- .block-products / end -->

<!-- Custom version with a simple max 4 grid layout taking the same div and class structure as the page that shows products per categories -->
<div class="container">
    <app-block-header *ngIf="products" [header]="header"></app-block-header>
    <app-block-header *ngIf="!products"[header]="'Loading products...'"></app-block-header>
    <div class="block">
        <div class="products-view">
            <div class="products-view__content">
                <div class="products-view__list products-list" [attr.data-layout]="'grid-4-full'">
                    <div class="products-list__body">
                        <div *ngFor="let product of products" class="products-list__item">
                            <app-product-card [product]="product"></app-product-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
